import { auth } from 'src/utils/firebase';

const apiUrl = process.env.REACT_APP_HOST_API;

const fetchData = async (endpoint, params, accessToken) => {
  accessToken = accessToken || (await auth.currentUser.getIdToken());
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    if (accessToken) {
      headers.Authorization = `Bearer ${accessToken}`;
    }

    const response = await fetch(`${apiUrl}${endpoint}`, {
      ...params,
      ...(params?.body && { body: JSON.stringify(params?.body ?? {}) }),
      headers,
    }).then((res) => res.json());

    return response;
  } catch (error) {
    // Handle errors here
    console.error(error.message);
    return {};
  }
};

export default fetchData;
